// extracted by mini-css-extract-plugin
export default {"aboutme":"About_aboutme__dPHwK","header":"About_header__uFA2i","learning":"About_learning__KX+WS","text":"About_text__jMZgi"};